import {
  LOCATIONS_FETCHING,
  LOCATIONS_FAILED,
  LOCATIONS_SUCCESS,
  LOCATIONS_CLEAR,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOCATIONS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case LOCATIONS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case LOCATIONS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case LOCATIONS_CLEAR:
      return { ...state, result: null, isFetching: false, isError: false };
    default:
      return state;
  }
}
